import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";


import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/Images/mentor.jpg";

const useStyles = makeStyles(styles);

export default function MentorPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        absolute
        color="transparent"
        brand="Rachit Mehrotra.io"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container}>

          <GridContainer justify="center">

            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color="info" className={classes.cardHeader}>
                    <h4>Spot Mentoring</h4>
                  </CardHeader>
                  <h2 className={classes.divider}>$ 49</h2>
                  <CardBody>
                    <h5 className={classes.divider}>
                      1 hour of candid conversation and advice as needed with no
                      long term commitment required.
                    </h5>
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <a
                      className={classes.navLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="rose"
                      href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=mehrotra.rachit.io@gmail.com"
                    >
                      <Button round color="google" size="lg">
                        Email
                      </Button>
                    </a>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color="info" className={classes.cardHeader}>
                    <h4>Production Support</h4>
                  </CardHeader>
                  <h2 className={classes.divider}>$ 400</h2>
                  <CardBody>
                    <h5 className={classes.divider}>
                      6 hours of targeted feedback and design critique to help
                      you focus on delivering your best work.
                    </h5>
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <a
                      className={classes.navLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="rose"
                      href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=mehrotra.rachit.io@gmail.com"
                    >
                      <Button round color="google" size="lg">
                        Email
                      </Button>
                    </a>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color="info" className={classes.cardHeader}>
                    <h4>Personal Learning</h4>
                  </CardHeader>
                  <h2 className={classes.divider}>$ 1000</h2>
                  <CardBody>
                    <h5 className={classes.divider}>
                      24 hours of professional coaching and collaboration to
                      help you achieve long term goals and ambitions.
                    </h5>
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <a
                      className={classes.navLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="rose"
                      href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=mehrotra.rachit.io@gmail.com"
                    >
                      <Button round color="google" size="lg">
                        Email
                      </Button>
                    </a>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
      </div>
    </div>
  );
}
